var map = {
	"./BDO.svg": 3375,
	"./claeren.png": 4618,
	"./holla.jpg": 6808,
	"./huijbregts.svg": 2969,
	"./micazu.jpg": 7471,
	"./rabobank.webp": 5871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2188;